module.exports = __webpack_public_path__ + "img/DiscrepancyBarClient.3cbe8ca3.png";